import builder from '../builder';
import Lock1 from '../../streamline-icons/light/lock-1.svg';

export default builder('IconLock1Light', Lock1);
